<template>
  <div class="min-height theme--light v-card pa-4 cbg-white-container">
    <loader v-if="isLoader"></loader>
    <v-row>
      <!-- <v-col cols="12" sm="12" lg="10" class="input-container">
        <v-row>
          <v-col cols="12" sm="6" lg="3" class="form-group pb-0 pb-lg-3 mb-1 mb-lg-3">
            <label for class="fz-10px">Search by Name</label>
            <div 
              class="search-div position-relative">
              <input 
               class="form-control" 
               label="Search by Name"
               v-model="name" 
               placeholder="Name" 
               @input="debounceSearch()"
               />
              <div
                v-if="search !== ''"
                class="search-svg"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="6" lg="3" class="pb-0 pb-lg-3">
            <label for>Speciality</label>
            <div class="position-relative table-select">
              <select
                name
                id
                class="form-control capitalize-text"
                v-model="speciality"
                @change="debounceSearch()"
              >
                <option value>Select</option>
                <option
                        v-for="(speciality, index) in dropDownSpecialities"
                        :value="speciality.speciality_id"
                        :key="index"
                      >
                        {{ speciality.speciality_type }}
                      </option>
                </select>
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="v-icon mdi mdi-menu-down theme--light position-absolute"
                ></i>
              </span>
            </div>
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <label for>Branch</label>
            <div class="position-relative  table-select">
              <select
                name
                id
                class="form-control"
                v-model="branch"
                @change="debounceSearch()"
              >
                <option value>Select</option>
                <option
                        v-for="(medicine, index) in branchOfMedicine"
                        :value="medicine.value"
                        :key="index"
                      >
                        {{ medicine.text }}
                      </option>
              </select>
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="v-icon mdi mdi-menu-down theme--light position-absolute"
                ></i>
              </span>
            </div>
          </v-col>
          <v-col cols="12" sm="6" lg="3">
            <label for>Qualifications</label>
            <div class="position-relative table-select">
              <select
                name
                id
                class="form-control capitalize-text"
                v-model="qualification"
                @change="debounceSearch()"
              >
                <option value>Select</option>
                <option
                      v-for="(qualification, index) in doctorQualifications"
                      :value="qualification"
                      :key="index"
                      >
                        {{ qualification }}
                      </option>
              </select>
              <span class="drop-icon">
                <i
                  aria-hidden="true"
                  class="v-icon mdi mdi-menu-down theme--light position-absolute"
                ></i>
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col> -->

      <v-col cols="12" sm="12" lg="2" class="d-flex  justify-end mt-0 mt-lg-6">
        <v-btn
              @click="downloadCsv()"
              class="btn btn-primary mr-0 px-6 py-5"
              >Export</v-btn
            >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="overflow-auto">
          <!-- changes done by durgesh on 21-1-2022 -->
          <table class="table userlistTable table-width add-table-width">
            <thead>
              <tr class="table-success">
                <!-- 0 -->
                <th scope="col" class="min-width-120">Doctor Name</th>
                <!-- 1 -->
                <th scope="col">Mobile Number</th>
                <!-- 2 -->
                <th scope="col">Speciality</th>
                <!-- 3 -->
                <th scope="col">Qualification</th>
                <!--  4-->
                <th scope="col" class="min-width-130">Location</th>
                <!--5-->
                <th scope="col">Appointment fees</th>
                <!-- 6 -->
                <th scope="col" class="min-width-140">
                  Insurance company names
                </th>
                <!-- 7 -->
              </tr>
            </thead>

            <!-- filter row -->
            <tbody>
              <tr>
                <!-- Doctor Name-->
                <td>
                  <input
                   label="Search by Name"
                   placeholder="Name"
                   v-model="name"
                   @input="debounceSearch()"
                   class="form-control"
                  />
                  <div
                
                class="search-svg position-absolute"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
                </td>

                <!-- Mobile Number -->
                <td>
                  <input
                    placeholder="Mobile Number"
                    v-model="mobile"
                    class="form-control"
                    @input="debounceSearch"
                    type="number"
                  />
                </td>

                <!-- 	Speciality -->
                <td>
                  <div class="position-relative table-select">
                    <select
                      name
                      id
                      class="form-control capitalize-text"
                      v-model="speciality"
                      @change="debounceSearch()"
                    >
                      <option value>Select</option>
                      <option
                        v-for="(speciality, index) in dropDownSpecialities"
                        :value="speciality.speciality_id"
                        :key="index"
                      >
                        {{ speciality.speciality_type }}
                      </option>
                    </select>
                    <span class="drop-icon">
                      <i
                        aria-hidden="true"
                        class="v-icon mdi mdi-menu-down theme--light position-absolute"
                      ></i>
                    </span>
                  </div>
                </td>

                <!-- 	Qualification -->
                <td>
                  <div class="position-relative w-7 table-select">
                    <select
                      name
                      id
                      class="form-control capitalize-text"
                      v-model="qualification"
                      @change="debounceSearch()"
                    >
                      <option value>Select</option>
                      <option
                        v-for="(qualification, index) in doctorQualifications"
                        :value="qualification"
                        :key="index"
                      >
                        {{ qualification }}
                      </option>
                    </select>
                    <span class="drop-icon">
                      <i
                        aria-hidden="true"
                        class="v-icon mdi mdi-menu-down theme--light position-absolute"
                      ></i>
                    </span>
                  </div>
                </td>
                <!-- Location  -->
                <td>
                  <input
                    placeholder="Search"
                    v-model="city"
                    @input="debounceSearch"
                    class="form-control"
                  />
                </td>

                <!-- appointment fees    -->
                <td>
                  
                </td>

                <!-- Insurance company names   -->
                <td>
                  <input
                    placeholder="Insurance List"
                    @input="debounceSearch()"
                    v-model="insuranceList"
                    class="form-control"
                  />
                </td>
              </tr>

              <tr v-for="(user, index) in UserList" :key="index">
                  <td class="pt-4 pb-4">{{user.first_name + " " + user.last_name}}</td>
                  <td class="pt-4 pb-4">{{ user.mobile ? user.mobile : "&#8213;" }}</td>
                  <td class="pt-4 pb-4">      {{
                    user.allied && user.allied.specialty && user.allied.specialty.length
                      ? user.allied.specialty[0].specialty_type
                      : "&#8213;"
                  }} <span v-if="user.allied && user.allied.specialty && user.allied.specialty.length > 1" class="d-block text-success font-weight-bold cursor pt-1" @click="showSpecialtyModal(user.allied.specialty)">+ {{user.allied.specialty.length}} more</span></td>
                       <td class="pt-4 pb-4">{{     
                        user && user.allied &&
                        user.allied.highest_qualification
                        ? user.allied.highest_qualification[0]
                        : "&#8213;"}}</td>
                  <td class="pt-4 pb-4">{{ Array.isArray(user.city) ? user.city[0] : user.city }}</td>
                 <td class="pt-4 pb-4">{{user.allied.docsmart_insurance ? user.allied.docsmart_insurance.doctor_consultancy_charge : "&#8213;" }}</td>
                  <td class="pt-4 pb-4">{{user.insurance_companies[0] ? user.insurance_companies[0].name : "&#8213;"}}  <span v-if="user.insurance_companies.length > 1" class="d-block text-success font-weight-bold cursor pt-1" @click="showCompanyInsuranceList(user.insurance_companies)"> + {{ user.insurance_companies.length - 1  }} more</span></td>
              </tr>
            </tbody>

            <tbody v-if="isEmpty">
              <tr>
                <td colspan="10">
                  <h2 class="text-center">No Data Found</h2>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination
        v-if="!isEmpty"
        class="mx-4 mob-t-center pagination-block"
        :recordPerPage="record_per_page"
        :total="total"
        @changePage="changePage"
      />
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="newSpeciality" width="500" persistent id="view-box">
        <new-speciality :specialities="specialitiesType" :insuranceName = insuranceName
        :title = "insuranceName.length ? 'Insurance List' : null" @close="newSpeciality=false, insuranceName=[], specialitiesType=[]"/>
      </v-dialog>
  </div>
</template>
<script>
// import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import debounce from "lodash/debounce";
import { bus } from "@/main.js";
import doctorQualifications from "@/data/doctorQualifications";
export default {
  data() {
    return {
      search: "",
      insuranceList: [],
      insuranceName: [],
      isEmpty: false,
      specialityStatus: "",
      qualification: "",
      branch: "",
      mobile: "",
      currentPage: 1,
      doctorQualifications: doctorQualifications,
      UserList: [],
      roleFuzzySearch: "",
      city: "",
      record_per_page: 10,
      specialitiesType:[],
      newSpeciality:false,
      companySpeciality: false,
      qualificationStatus: "",
      roleStatus: "",
      name: "",
      total: 0,
      speciality: "",
      dropDownSpecialities: [],
      branchOfMedicine: [
        {
          text: "Allopathy",
          value: "Allopathy",
        },
        {
          text: "Ayurvedic",
          value: "Ayurvedic",
        },
        {
          text: "Homeopathy",
          value: "Homeopathy",
        },
        {
          text: "Unani",
          value: "Unani",
        },
        {
          text: "Siddha",
          value: "Siddha",
        },
      ],
    };
  },
  components: {
      'new-speciality': () => import('@/components/modals/newSpeciality'),
    ...pickSvg("crossSVG", "verticalDotsSVG"),
    pagination: () => import("@/views/common/Pagination"),
    loader: () => import("@/components/loader.vue"),
  },
  computed: {
    isLoader() {
      return this.$store.state.general.isLoader;
    },
  },
  mounted(){
    this.getSpecialities()
    this.changePage(null, true);
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    getSpecialities() {
      let url = `${config.BASE_URL}api/v2/doctor/master/specialities-complains`;
      this.$http.get(url).then((response) => {
        response = response.body;
        if (response.status) {
          this.dropDownSpecialities = response.data.specialities;
        }
      });
    },
    changePage(page = { currentPage: 1, reduced: false }, reset = false) {
      if (reset) {
        bus.$emit("PAGE_CHANGE");
        page = { currentPage: 1, reduced: false }
      }
      if (!page.reduced) {
        this.currentPage = page.currentPage;
        this.debounceSearch();
      } else {
        this.currentPage = 1;
        this.$forceUpdate();
      }
    },
    showCompanyInsuranceList(list){
      list.map((type) => {this.insuranceName.push(type.name)})
      this.newSpeciality = true;
    },
    showSpecialtyModal(data){
      this.specialitiesType = data.map(el => el.specialty_type);
      this.newSpeciality = true
    },
    debounceSearch: debounce(function () {
      this.getUserList();
    }, 800),
    getUserList() {
      this.$store.commit("general/setLoader", true);
      this.roleStatus = this.$route.path.replace('/insurance-','')
      let userParams = {
        reference_code: this.referenceCode,
        page: this.currentPage,
        record_per_page: this.record_per_page,
        user_name: this.name,
        qualification: this.qualification,
        speciality: this.speciality === 1009 ? 0 : this.speciality,
        branch_of_medicine: this.branch,
        mobile: this.mobile,
        is_part_of_docsmart_insurance: true,
        city: this.city,
        insurance_company_name: this.insuranceList,
        // verified: this.verified,
        role: this.roleStatus,
        // last_seen_to: this.toDate,
        // is_completed: this.isCompleted,
        fuzzy_role_search: this.roleFuzzySearch,
        // sort_by:
        //   this.$router.currentRoute.name == "User Listing" ? "created_at" : "",
        // joined_on_from:
        //   this.joinOnDateRange.start === ""
        //     ? ""
        //     : new Date(this.joinOnDateRange.start).toISOString(),
        // joined_on_to:
        //   this.joinOnDateRange.end === ""
        //     ? ""
        //     : new Date(this.joinOnDateRange.end).toISOString(),
      };
      
      userParams.is_completed === ""
        ? delete userParams.is_completed
        : userParams;
      let url = `${config.BASE_URL}api/v2/admin/users-listing`;
      let params = userParams;
      this.$http.get(url, { params }).then((res) => {
        if (res.status) {
          this.$store.commit("general/setLoader", false);
          if (res && res.data && res.data.data && res.data.data.list.length) {
            this.UserList = res.data.data.list;
            this.isEmpty = false;
          } else {
            this.UserList = [];
            this.isEmpty = true;
          }
          this.currentPage = res.data.data.page;
          this.dateRangeActive = false;
          this.total = res.data.data.count;
        } else {
          this.$store.commit("general/setLoader", false);
          this.UserList = [];
          this.isEmpty = true;
        }
      });
    },
    downloadCsv() {
      this.$store.commit("general/setLoader", true);
      this.roleStatus = this.$route.path.replace('/insurance-','')
      let params = {
        user_name: this.name,
        qualification: this.qualification,
        speciality: this.speciality,
        branch_of_medicine: this.branch,
        mobile: this.mobile,
        city: this.city,
        verified: this.verified,
        is_part_of_docsmart_insurance: true,
        role: this.roleStatus,
        last_seen_from: this.fromDate,
        last_seen_to: this.toDate,
        is_completed: this.isCompleted,
        sort_by:
          this.$router.currentRoute.name == "User Listing" ? "created_at" : "",
      };
      let url = `${config.BASE_URL}api/v2/admin/users-listing-csv`;
      this.$http.get(url, { params }).then((response) => {
        this.$store.commit("general/setLoader", false);
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(
          new Blob(["\ufeff", response.body])
        );
        downloadLink.download = "export_users_listing.csv";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
       if (route && route.path) {
        this.roleStatus = this.$route.path.replace('/insurance-','')   
        // this.debounceSearch();
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.ww-50 {
  width: 50px;
}
.action-div {
  .dropdown-menu {
    padding: 0px !important;
  }
}
</style>